import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import menuDetail from './menuDetail';
import { setUserTheme } from '@/api/user';
import { getIsLessSevent } from '@/api/system/alarm/alarm';
var projectname = process.env.VUE_APP_PROJECT_NAME;
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    menuDetail: menuDetail
  },
  data: function data() {
    return {
      navMenu: null,
      navMenuIndex: 0,
      judgeMenu: false,
      routes: [],
      pageRoutes: [],
      userName: ''
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar'])), mapState({
    choosen_router: function choosen_router(state) {
      return state.permission.choosenRouters;
    },
    permission_routers: function permission_routers(state) {
      return state.permission.routers;
    },
    userTheme: function userTheme(state) {
      return state.user.userTheme;
    },
    userId: function userId(state) {
      return state.user.userId;
    },
    userType: function userType(state) {
      return state.user.userType;
    },
    nineRead: function nineRead(state) {
      return state.user.nineRead;
    }
  })), {}, {
    isZqpt: function isZqpt() {
      return this.$store.state.user.userType === 8;
    },
    navLogo: function navLogo() {
      return {
        'zhwgLogo': this.isZqpt,
        'blueLogo': this.userTheme,
        'defaultLogo': !this.userTheme
      };
    },
    logoUrl: function logoUrl() {
      if (projectname && projectname === 'SLXC') {
        if (this.userTheme) {
          return 'static/img/slxc/xin-blue.png';
        } else {
          return 'static/img/slxc/xin-green.png';
        }
      } else if (this.userType !== 4) {
        if (this.isZqpt) {
          return 'static/img/zhwg_logo.png';
        } else if (this.userTheme) {
          return 'static/img/zhsq-logo_blue.png';
        } else {
          return 'static/img/zhsq-logo_green.png';
        }
      } else {
        if (this.userTheme) {
          return 'static/img/mlxc/mlxc-logo_blue.png';
        } else {
          return 'static/img/mlxc/mlxc-logo_green.png';
        }
      }
    },
    userUrl: function userUrl() {
      if (this.userTheme || this.isZqpt) {
        return 'static/img/houtai_user2.png';
      } else {
        return 'static/img/houtai_user.png';
      }
    }
  }),
  watch: {
    $route: {
      handler: function handler(val, old) {// if (val.fullPath === '/back/navigation') {
        //   this.navMenu.innerText = '首页'
        // } else {
        //   this.navMenu.innerText = '返回首页'
        // }
      },
      deep: true
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.userName = this.$store.getters.name;
    this.initRouters();

    if (this.$route.name === 'Dashboard') {
      this.judgeMenu = true;
      this.$emit('changeMainStyle', false);
    } else if (this.$route.name === 'dashboard') {
      this.$emit('changeMainStyle', false);
    } else {
      this.judgeMenu = false;
      this.$emit('changeMainStyle', true);
    }

    this.setFirstNavMenuTitle();
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    setFirstNavMenuTitle: function setFirstNavMenuTitle() {// this.$nextTick(() => {
      //   this.navMenu = document.querySelector('.navbar .el-menu-item div')
      //   if (this.$route.fullPath !== '/back/navigation') {
      //     this.navMenu.innerText = '返回首页'
      //   }
      // })
    },
    handleThemeSet: function handleThemeSet(userTheme) {
      var _this = this;

      var paramObj = {
        userId: this.userId,
        userTheme: userTheme
      };
      setUserTheme(paramObj).then(function (res) {
        if (res.data.code === 200) {
          if (userTheme) {
            _this.$store.commit('SET_USERTHEME', userTheme);
          } else {
            _this.$store.commit('SET_USERTHEME', '');
          }

          _this.Alert({
            alertType: 'update',
            message: '主题已更换'
          });
        }
      });
    },
    handleMenuActive: function handleMenuActive(index) {
      this.navMenuIndex = index;
    },
    isMenuActive: function isMenuActive(index) {
      if (index === this.navMenuIndex && this.isZqpt) {
        return true;
      }

      if (index === this.navMenuIndex && this.userTheme) {
        return true;
      }

      return false;
    },
    handSelect: function handSelect(indexPath, index) {
      console.log('进入方法' + index + '-' + indexPath);

      if (indexPath === '/') {
        // 点击首页
        this.judgeMenu = true;
        this.$emit('changeMainStyle', false);
      } else if (indexPath === '/back') {
        // 点击快速导航
        this.judgeMenu = false;
        this.$emit('changeMainStyle', false);
      } else if (index[0] === null && indexPath === null && this.judgeMenu === true) {
        this.judgeMenu = false;
        this.$emit('changeMainStyle', false);
      } else if (this.$route.name === 'Dashboard') {
        this.judgeMenu = false;
        this.$emit('changeMainStyle', false);
      }

      if (indexPath !== null) {
        this.$store.dispatch('ChooseRouters', null).then(function () {}).catch(function () {
          console.log('修改左侧菜单失败！');
        });
      }
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$confirm('准备退出系统, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  confirmButtonClass: 'btnFalses'
                }).then(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this2.$store.dispatch('LogOut');

                        case 2:
                          location.reload(); // this.$router.push(`/login?redirect=${this.$route.fullPath}`)

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))).catch(function () {});

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    initRouters: function initRouters() {
      var _this3 = this;

      // 初始化读取的权限菜单
      this.routes = [];

      if (this.permission_routers !== null && this.permission_routers !== undefined) {
        var list = [];
        this.permission_routers.forEach(function (item) {
          if (!item.hidden) {
            // 如果是隐藏目录则不显示
            _this3.routes.push(item);

            if (list.length > 8) {
              _this3.pageRoutes.push(list);

              list = [];
            } else {
              list.push(item);
            }
          }
        });
        console.log('分页路由', this.pageRoutes);
      }

      console.log(this.routes);
    },
    hasOneShowingChildren: function hasOneShowingChildren(children) {
      // 是否直接显示只有一个子菜单的对象
      if (children) {
        var showingChildren = children.filter(function (item) {
          return !item.hidden;
        });

        if (showingChildren.length === 1) {
          return true;
        }
      }

      return false;
    },
    showName: function showName(item) {
      if (this.isZqpt) {
        // 政企平台
        if (item.path === '/back') return '首页';
      } else {
        if (!item.meta) {
          return item.children[0].meta.title;
        }

        return item.meta.title;
      }
    },
    hiddenProver: function hiddenProver(router) {
      // 隐藏对应的值
      this.routes.forEach(function (item) {
        if (item.menuId === router.menuId) {
          item.isShowMenu = false;
        }
      });
      this.$emit('changeMainStyle', true);
    },
    getIndex: function getIndex(item, index) {
      // 获取应该跳转的地址
      if (item.path === '/back' || item.path === '/') {
        return item.path;
      }

      if (this.hasOneShowingChildren(item.children)) {
        return null;
      }
    },
    // 90天
    nines: function nines() {
      var _this4 = this;

      getIsLessSevent({}).then(function (response) {
        var nines = response.data.data;

        if (nines.isLessSevent === 1) {
          _this4.$message({
            showClose: true,
            message: '您的密码将在' + nines.lessDate + '后到期，请您及时前往【系统管理】-【用户管理】修改密码。若到期未修改，该账号会被锁定，锁定账号可前往登录页忘记密码重新设置密码',
            type: 'warning',
            duration: 0,
            onClose: function onClose() {
              _this4.$store.commit('SET_NINETY_READ', 1);
            }
          });
        }
      });
    }
  }
};